module.exports = __webpack_public_path__ + "img/pc_p2_ganzhixinxi.615f3110.png";